// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file
 * @author James Reid
 */

// @ts-check

// @@imports-submodule
import { getDefaultBreakdown } from "./breakdowns/index.js"

// @@imports-types
import { Bom } from "../../../../../package/index.js"
// import { ProductCard } from "../../../components/index.js"

// @@body
/**
 * 
 * @param {HTMLElement} card
 * @param {Bom} bom
 */
const populateDefaultCard = (card, bom, state) => {
    card.bom = bom

    const price = /** @type {HTMLSpanElement?} */
        (card.querySelector("span.price"))
    if (price && bom.price) { price.innerText = bom.price.toFixed(2) }
    else { price?.parentElement?.remove() }

    card.querySelector("tbody")?.replaceWith(getDefaultBreakdown(bom))

    const image = document.createElement("img")
    image.src = bom.lineItems[0].product.imageUrl
    card.querySelector("div")?.append(image)
}

// @@exports
export { populateDefaultCard }
